/* @flow */
export default {
  NODE_ENV: process.env.NODE_ENV,
  IS_ENV_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_ENV_PRODUCTION: process.env.NODE_ENV === 'production',
  LIFERAY_URL: process.env.REACT_APP_LIFERAY_URL || '',
  LIFERAY_FORGOT_URL: `${process.env.REACT_APP_LIFERAY_URL ||
    ''}/web/guest/home?p_p_id=58&p_p_lifecycle=0&p_p_state=maximized&_58_struts_action=%2Flogin%2Fforgot_password`,
  MEDIA_SERVER_URL: process.env.REACT_APP_MEDIA_SERVER_URL || '',
  STATIC_ASSETS_URL: process.env.REACT_APP_STATIC_ASSETS_URL || '',
  DISPLAY_VERSION: process.env.REACT_APP_DISPLAY_VERSION,
  REDUX_PERSIST_REDUCER_VERSION: process.env.REACT_APP_REDUX_PERSIST_REDUCER_VERSION || '1',
  REDUX_PERSIST_ACTIVE: true,
};
